import { createSelector } from "@reduxjs/toolkit";
import { getOrderItemsWithFormattedPrice } from "../../utils/getOrderItemsWithFormattedPrice";
export const selectOrder = createSelector((state) => state.order.orderDetails.data, (state) => state.cart.currency, (order, currency) => {
    return getOrderItemsWithFormattedPrice(order, currency);
});
//# sourceMappingURL=selectOrder.js.map